module.exports = __webpack_public_path__ + "static/media/Puneet_Gangwal.142cd895.jpg";